<template lang="html">
  <div id="Stage"
       @mousemove="handleMouse"
       @touchstart="swipeStart"
       @touchmove="swipeMove"
       @touchend="swipeEnd">
    <transition mode="out-in" name="scene-transition" :duration="500">
      <component v-bind:is="current"></component>
    </transition>
    <Loader v-if="loader" />
    <Nav :show="displayUI" :setShow="setDisplayUI" :uiOverride="setDisplayUIOverride" />
    <NavMobile :show="displayUI" :setShow="setDisplayUI" :uiOverride="setDisplayUIOverride" />
    <Controls :show="displayUI" :uiOverride="setDisplayUIOverride" />
    <Escape :show="displayUI" :active="escapeActive" :set="setEscape" :uiOverride="setDisplayUIOverride" />
    <Audio />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import Slide                    from "./Slide.vue"
import Nav                      from "./Nav.vue"
import NavMobile                from "./NavMobile.vue"
import Escape                   from "./Escape.vue"
import Loader                   from "./Loader.vue"
import Audio                      from "./Audio.vue"
import FullscreenToggler        from "./FullscreenToggler.vue"
import Controls                 from "./Controls.vue"

import HowTo          from "./Scenes/HowTo.vue"
import Credits        from "./Scenes/Credits.vue"
import Foreword       from "./Scenes/Foreword.vue"
import Narration      from "./Scenes/Narration.vue"
import Hogan          from "./Scenes/Hogan.vue"
import Classroom      from "./Scenes/Classroom.vue"
import Map            from "./Scenes/Map.vue"
import Haskell        from "./Scenes/Haskell.vue"
import Shonto         from "./Scenes/Shonto.vue"
import JohnAustin     from "./Scenes/JohnAustin.vue"
import Wedding        from "./Scenes/Wedding.vue"
import Tsegi          from "./Scenes/Tsegi.vue"
import Bucket         from "./Scenes/Bucket.vue"
import ExpeditionA    from "./Scenes/ExpeditionA.vue"
import ExpeditionB    from "./Scenes/ExpeditionB.vue"
import Footprints     from "./Scenes/Footprints.vue"
import Lowrey         from "./Scenes/Lowrey.vue"
import Legend         from "./Scenes/Legend.vue"
import Burro          from "./Scenes/Burro.vue"
import HorseRide      from "./Scenes/HorseRide.vue"
import CliffDwellings from "./Scenes/CliffDwellings.vue"
import HorseWalk      from "./Scenes/HorseWalk.vue"
import Judge          from "./Scenes/Judge.vue"
import Foster         from "./Scenes/Foster.vue"
import Old            from "./Scenes/Old.vue"
import Sun            from "./Scenes/Sun.vue"
import Silhouette     from "./Scenes/Silhouette.vue"
import Fin            from "./Scenes/Fin.vue"
import Attribution            from "./Scenes/Attribution.vue"

const sceneMap = {
  "how-to":      HowTo,
  "credits":     Credits,
  "foreword":    Foreword,
  "narration":   Narration,
  "scene-1":     Hogan,
  "scene-2":     Classroom,
  "scene-3":     Map,
  "scene-4":     Haskell,
  "scene-5":     Shonto,
  "scene-6":     JohnAustin,
  "scene-7":     Wedding,
  "scene-8":     Tsegi,
  "scene-9":     Bucket,
  "scene-10":    ExpeditionA,
  "scene-11":    ExpeditionB,
  "scene-12":    Footprints,
  "scene-13":    Lowrey,
  "scene-14":    Legend,
  "scene-15":    Burro,
  "scene-16":    HorseRide,
  "scene-17":    CliffDwellings,
  "scene-18":    HorseWalk,
  "scene-19":    Judge,
  "scene-20":    Foster,
  "scene-21":    Old,
  "scene-22":    Sun,
  "scene-23":    Silhouette,
  "fin":         Fin,
  "attribution": Attribution,
}

export default {
  data: function() { return {
    escapeActive: false,
    navActive: false,
    uiTmt: null,
    touchTmt: null,
    touchHot: false,
    displayUI: false,
    displayUIOverride: false,
    swipeBegin: 0,
    swipeHot: false,
  } },
  computed: {
    ...mapState([
      "slides",
      "sequence",
      "loader",
      "current",
    ]),
  },
  watch: {
    $route: function(to, from) {
      this.setLoader(true)
      this.setCurrent(to.params.slug)
    },
  },
  created() {
    this.setLoader(true)
    this.setCurrent(this.$route.params.slug)
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll)
  },
  methods: {
    ...mapActions(['setLoader', 'setCurrent']),
    setDisplayUI(to) { this.displayUI = to },
    setDisplayUIOverride(to) { this.displayUIOverride = to },
    setEscape(to) { this.escapeActive = to },
    handleScroll() {
      // if scrolling window then we must be zoomed in
      this.swipeHot = false
      this.swiping = false
      window.clearTimeout(this.swipeTimeout)
    },
    handleMouse() {
      window.clearTimeout(this.uiTmt)
      if (!this.displayUI) { this.setDisplayUI(true) }
      this.uiTmt = window.setTimeout(() => {
        if (this.displayUIOverride) { return }
        this.setDisplayUI(false)
      }, 1000)
    },
    swipeStart(e) {
      // console.log(e.targetTouches)
      if (e.targetTouches.length > 1) {
        this.swipeHot = false
        this.swiping = false
        // window.clearTimeout(this.swipeTimeout)
        return
      }
      this.swipeHot = true
      window.clearTimeout(this.swipeTimeout)
      this.swipeTimeout = window.setTimeout(() => {
        this.swipeHot = false
        this.swiping = false
      }, 500)
      this.swipeBeginX = e.targetTouches[0].clientX
    },
    swipeMove(e) {
      if (e.targetTouches.length > 1) { return }
      if (this.swipeHot) { this.swiping = true }
    },
    swipeEnd(e) {
      e.preventDefault()
      if (e.targetTouches.length > 1) {
        this.swipeHot = false
        this.swiping = false
        // window.clearTimeout(this.swipeTimeout)
        return
      }
      if (!this.swiping) {
        this.setDisplayUI(!this.displayUI)
        return
      }
      window.clearTimeout(this.swipeTimeout)
      this.swiping = false

      const x = e.changedTouches[0].clientX
      if (x < this.swipeBeginX - 100) {
        const curr = this.sequence.findIndex(s => this.current === s)
        const next = this.sequence[curr+1]
        if (next) { this.$router.push(`/${next}`) }
      }
      if (x > this.swipeBeginX + 100) {
        const curr = this.sequence.findIndex(s => this.current === s)
        const prev = this.sequence[curr-1]
        if (prev) { this.$router.push(`/${prev}`) }
      }
    },
  },
  components: {
    Slide,
    Nav,
    NavMobile,
    Escape,
    Loader,
    FullscreenToggler,
    Controls,
    Audio,
    ...sceneMap,
  }
}
</script>

<style lang="scss">
#Stage {
  width: 100%; height: 100%; overflow: hidden; -webkit-overflow-scrolling: auto;
}
.slide {
  height: 100%; width: 100%; background-size:contain;
  background-repeat: no-repeat; background-position: center;
  transition: opacity 0.5s ease;
  &.scene-transition-leave-active { opacity: 0 }
  .canvas { width: 100%; height: 100%; }
}
</style>
